import { GridApi, GridReadyEvent, SelectionChangedEvent } from "ag-grid-community";
import _ from "lodash";
import { action, makeObservable, observable } from "mobx";
import ProjectJobRolesApi, {
  ProjectJobRolesApi as IProjectJobRolesApi
} from "../../../../../../../services/api/v2/projectJobRoles/ProjectJobRoles.api";
import RolesApi, { RolesApi as IRolesApi } from "../../../../../../../services/api/v2/roles/Roles.api";

export class JobRolesGridModel {
  projectId: number;
  organisationId: number;
  rolesProvider: IRolesApi;
  @observable isLoading: boolean = true;
  @observable gridData: FP.Entities.IImpactSummary[];
  authUser: FP.Entities.IUser;
  @observable.ref selectedJobRoles: number[] = [];
  gridApi: GridApi;
  searchText: string;
  projectJobRolesProvider: IProjectJobRolesApi;

  /**
   *
   */
  constructor(projectId: number, organisationId: number, authUser: FP.Entities.IUser) {
    makeObservable(this);
    this.projectId = projectId;
    this.rolesProvider = RolesApi;
    this.projectJobRolesProvider = ProjectJobRolesApi;
    this.organisationId = organisationId;
    this.authUser = authUser;
  }

  onMount = async () => {
    this.loadJobRoles();
  };

  onUnmount = () => {};

  loadJobRoles = async () => {
    let res = await this.rolesProvider.getFiltered(this.organisationId, { page: 1, pageSize: 10000 });
    if (res.isError) return;

    this.setGridData(res.payload.map(e => ({ id: e.id, name: e.name, businessArea: e.businessArea.name })));
  };

  @action
  setGridData = jobRoles => {
    this.gridData = jobRoles;
    this.isLoading = false;
  };

  @action
  onGridReady = (gridReadyEvent: GridReadyEvent) => {
    this.gridApi = gridReadyEvent.api;
  };

  @action
  setSearchText = (ev: React.FormEvent<HTMLInputElement>) => {
    this.searchText = ev.currentTarget.value;

    if (this.gridApi !== undefined) {
      this.gridApi.setGridOption("quickFilterText", this.searchText);
    }
  };

  @action
  updateSelectedJobRoles = (event: SelectionChangedEvent) => {
    this.gridApi = event.api;
    this.selectedJobRoles = _.map(event.api.getSelectedNodes(), e => {
      return e.data.id;
    });
  };

  assignJobRoles = async () => {
    return await this.projectJobRolesProvider.assignJobRoles(
      this.organisationId,
      this.projectId,
      this.selectedJobRoles
    );
  };
}
